<script>
import formatDate from '@utils/format-date'
import formatGender from "@utils/format-gender";
import { authComputed, merchantComputed } from "@store/helpers";
import formatServiceTime from "@utils/format-service-time";
import formatCurrency from "@utils/format-currency";

export default {
  components: {
    SectionBanner: () => import("./SectionBanner"),
    DetailOrderReservation: () => import("./DetailOrderReservation.Jtails"),
    DetailOrderPrepaid: () => import("./DetailOrderPrepaid.Jtails"),
    DetailOrderDeposit: () => import("./DetailOrderDeposit.Jtails"),
  },
  props: {
    orderItem: {
      type: Object,
      required: true
    },
    orderType: {
      type: String,
      required: true,
      validator(value) {
        return [
          'reservation',
          'prepaid',
          'children',
          'deposit',
        ].includes(value)
      },
    },
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    componentDetail() {
      const componentDetailMap = {
        'reservation': 'DetailOrderReservation',
        'prepaid': 'DetailOrderPrepaid',
        'children': 'DetailOrderReservation',
        'deposit': 'DetailOrderDeposit',
      };

      return componentDetailMap[this.orderType]
    },
    storeList() {
      switch (this.orderType) {
        case 'prepaid':
          return this.orderItem.stores;
        case 'children':
        case 'reservation':
        default:
          return [this.orderItem.param.store];
      }
    }
  },
  mounted() {
    console.log(this.orderItem)
    console.log(this.orderItem.status)
  },
  methods: {
    formatCurrency,
    formatGender,
    formatDate,
    formatServiceTime,
    goToGoogleCalendar(orderItem) {
      // dates   時間格式為 YYYYMMDDTHHMMSS
      // details 使用 %0A 作為跳行
      const text = `[${this.currentMerchant.title}${orderItem.param.store.title}] ${orderItem.pet.name} - ${orderItem.param.title}` || '';
      const start = orderItem.startDate
        .replace(/-/g, '')
        .replace(/:/g, '')
        .replace(/\s/g, 'T');
      const end = orderItem.endDate
        .replace(/-/g, '')
        .replace(/:/g, '')
        .replace(/\s/g, 'T');
      const dates = `${start}/${end}`;
      const details = orderItem.param.description || '';
      const location = orderItem.param.store.fullAddress;
      const query = `action=TEMPLATE&text=${text}&dates=${dates}&details=${details}&location=${location}&trp=false`;

      return `http://www.google.com/calendar/event?${query}`
    },
    goToMemberReservationItem(orderItem) {
      console.log("🚀 ~ file: DetailOrder.Jtails.vue:82 ~ goToMemberReservationItem ~ orderItem:", orderItem)
      const loggedInFn = () => {
        this.$nextTick(() => {
          this.$router.push({
            name: 'member-reservation-item',
            params: {
              containerUuid: orderItem.uuid
            }
          })
        });
      };
      console.log(this.isLoggedIn)
      if (this.isLoggedIn) {
        loggedInFn()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn()
          }
        })
      }
    },
    goToMemberReservationItemChildren(orderItem) {
      const loggedInFn = () => {
        this.$nextTick(() => {
          this.$router.push({
            name: 'member-reservation-item',
            params: {
              containerUuid: orderItem.parentOrderContainerUuid
            },
            // query: {
            //   activeTab: 'children'
            // }
          })
        });
      };

      if (this.isLoggedIn) {
        loggedInFn()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn()
          }
        })
      }
    },
    goToMemberPrepaidItem(orderItem) {
      const loggedInFn = () => {
        this.$nextTick(() => {
          this.$router.push({
            name: 'member-prepaid-item',
            params: {
              prepaidOrderId: orderItem.id
            },
            query: {
              activeTab: 'detail'
            }
          })
        });
      };

      if (this.isLoggedIn) {
        loggedInFn()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn()
          }
        })
      }
    },
    goToMemberPrepaidItemApplicable(orderItem) {
      const loggedInFn = () => {
        this.$nextTick(() => {
          this.$router.push({
            name: 'member-prepaid-item',
            params: {
              prepaidOrderId: orderItem.id
            },
            query: {
              activeTab: 'applicable'
            }
          })
        });

      };

      if (this.isLoggedIn) {
        loggedInFn()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn()
          }
        })
      }
    },
    goToMemberDepositItem(orderItem) {
      const loggedInFn = () => {
        this.$nextTick(() => {
          this.$router.push({
            name: 'member-deposit-item',
            params: {
              depositOrderId: orderItem.uuid
            }
          })
        })
      };
      if (this.isLoggedIn) {
        loggedInFn()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn()
          }
        })
      }
    },
    openDialogContact(option) {
      this.$globalDialog('DialogContact', {
        storeList: option || this.storeList
      });
    },
    openDialogPrepaid() {
      this.$globalDialog('DialogPrepaid', {
        ...this.orderItem.prepaid,
        stores: this.orderItem.stores
      });
    },
    openDialogOrderDetails() {
      this.$globalDialog('DialogOrderDetails', {
        type: 'children',
        containerItem: this.orderItem,
      })
    }
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.detailOrder">
    <SectionBanner :title="`${orderItem.fullName}${formatGender(orderItem.gender)}`" type="B"
      :description="`以下是您的訂單（#${orderItem.orderNo || orderItem.displayId}）資訊`" class="detailOrder__banner" />
    <section :class="[$style.sectionDetail, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]" class="section">
      <div class="container">
        <div class="sectionDetail__detailBox">
          <!-- <div
            v-if="orderType === 'reservation'"
            class="sectionDetail__detailBoxInner text-center"
          >
            <div class="sectionDetail__date">
              {{ formatDate(orderItem.startDate, 'MM/dd (EEE)') }}
            </div>
            <div class="sectionDetail__time">
              {{ formatDate(orderItem.startDate, 'HH:mm') }}
            </div>
            <div class="sectionDetail__hour">
              (預計{{ formatServiceTime(orderItem.param.serviceTime) }})
            </div>
          </div> -->
          <div class="sectionDetail__detailBoxInner">
            <component :is="componentDetail" :order-item="orderItem"></component>
            <div v-if="orderItem.paymentMethod === 'Deposit'" class="sectionDetail__depositBalance mt-4">
              <i class="fal fa-usd-circle mr-2"></i>
              <span class="font-number fw-bold">儲值金剩餘{{ formatCurrency(currentMember.point) }}點</span>
            </div>
          </div>
          <hr class="sectionDetail__hr">
          <div class="sectionDetail__detailBoxInner">
            <!--預約-->
            <template v-if="orderType === 'reservation'">
              <BaseButton class="isStylePrimary isFull mb-3" :class="{ 'isRadius': $globalIsJtails }"
                @click="goToMemberReservationItem(orderItem)">
                查看訂單詳情<span v-if="!isLoggedIn">(需登入)</span>
              </BaseButton>
              <BaseButton v-if="orderItem.childrenContainers && orderItem.childrenContainers.items[0]"
                class="isStylePrimary isOutline3 isFull mb-3" :class="{ 'isRadius': $globalIsJtails }"
                @click="openDialogOrderDetails(orderItem)">
                查看子訂單
              </BaseButton>
              <BaseButton class="isOutline3 isFull"
                :class="{ 'isStylePrimary isRadius': $globalIsJtails, 'isStyleSecondary': $globalIsDingBeauty }"
                @click="openDialogContact([orderItem.orders.items[0].param.store])">
                聯繫我們
              </BaseButton>
            </template>
            <!--包套方案-->
            <template v-if="orderType === 'prepaid'">
              <BaseButton v-if="orderItem.status !== 0 && orderItem.status !== 2" class="isStylePrimary isFull mb-3"
                :class="{ 'isRadius': $globalIsJtails }" @click="goToMemberPrepaidItemApplicable(orderItem)">
                使用{{ `${currentMerchant.prepaidSetting.title || '包套方案'}` }}<span v-if="!isLoggedIn">(需登入)</span>
              </BaseButton>
              <BaseButton v-if="orderItem.status !== 2" class="isStylePrimary isOutline3 isFull mb-3"
                :class="{ 'isRadius isStylePrimary': $globalIsJtails, 'isStyleSecondary': $globalIsDingBeauty }"
                @click="goToMemberPrepaidItem(orderItem)">
                查看訂單詳情<span v-if="!isLoggedIn">(需登入)</span>
              </BaseButton>
              <BaseButton class="isStylePrimary isOutline3 isFull"
                :class="{ 'isRadius': $globalIsJtails, 'isStyleSecondary': $globalIsDingBeauty }"
                @click="openDialogContact">
                聯繫我們
              </BaseButton>
            </template>
            <!--子訂單-->
            <template v-if="orderType === 'children'">
              <BaseButton class="isStylePrimary isFull mb-3"
                :class="{ 'isRadius': $globalIsJtails, 'isStyleSecondary': $globalIsDingBeauty }"
                @click="goToMemberReservationItemChildren(orderItem)">
                查看訂單詳情<span v-if="!isLoggedIn">(需登入)</span>
              </BaseButton>
            </template>
            <!--儲值金-->
            <template v-if="orderType === 'deposit'">
              <div v-if="orderItem.paymentStatus === 'PAID'" class="row">
                <div v-if="currentMerchant.prepaidSetting.isEnabled" class="col-md-12">
                  <BaseButton class="isStylePrimary isFull mb-3"
                    :class="{ 'isRadius': $globalIsJtails, 'isStyleSecondary': $globalIsDingBeauty }"
                    :to="{ name: 'prepaid' }">
                    {{ `購買${currentMerchant.prepaidSetting.title || $t('site.PREPAID_TITLE')}` }}
                  </BaseButton>
                </div>
              </div>
              <BaseButton class="isStylePrimary isFull mb-3"
                :class="{ 'isOutline3': 'status' in orderItem && orderItem.status !== 0 && orderItem.status !== 2, 'isRadius isStylePrimary': $globalIsJtails, 'isStyleSecondary': $globalIsDingBeauty }"
                @click="goToMemberDepositItem(orderItem)">
                查看訂單詳情<span v-if="!isLoggedIn">(需登入)</span>
              </BaseButton>
              <BaseButton class="isOutline3 isFull"
                :class="{ 'isStylePrimary isRadius': $globalIsJtails, 'isStyleSecondary': $globalIsDingBeauty }"
                @click="openDialogContact([currentMerchant])">
                聯繫我們
              </BaseButton>
            </template>
          </div>
        </div>
        <div class="sectionDetail__outlineBox">
          <!--預約-->
          <!-- <template v-if="orderType === 'reservation'">
            <BaseButton
              class="isStylePrimary isOutline3 isRadius isFull"
              :to="{ name: 'reservation-item', params: { reservationAlias: orderItem.param.alias, storeAlias: orderItem.param.store.alias } }"
            >
              查看服務資訊
            </BaseButton>
          </template> -->
          <!--包套方案-->
          <template v-if="orderType === 'prepaid'">
            <BaseButton class="isStylePrimary isOutline3 isFull"
              :class="{ 'isRadius': $globalIsJtails, 'isStyleSecondary': $globalIsDingBeauty }"
              @click="openDialogPrepaid">
              查看{{ `${currentMerchant.prepaidSetting.title || $t('site.PREPAID_TITLE')}` }}資訊
            </BaseButton>
          </template>
          <!--子訂單-->
          <template v-if="orderType === 'children'">
            <BaseButton class="isStylePrimary isOutline3 isFull"
              :class="{ 'isRadius': $globalIsJtails, 'isStyleSecondary': $globalIsDingBeauty }"
              @click="openDialogContact([orderItem.orders.items[0].param.store])">
              聯繫我們
            </BaseButton>
          </template>
        </div>
      </div>
    </section>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.detailOrder {
  :global {
    .detailOrder {
      @include unstyled;
    }
  }
}

.sectionDetail {
  position: relative;
  z-index: 1;
  padding-top: 0;

  :global {
    .sectionDetail {
      &__detailBox {
        position: relative;
        margin-top: -15rem;
        background: #FFF;
        border-top: 4px solid $color-primary;
        box-shadow: 2px 8px 36px #1C2C5414;

        @include max-md {
          margin-top: 0;
          margin-right: -$container-gap;
          margin-left: -$container-gap;
          border-radius: 0;
        }

        &::before {
          position: absolute;
          top: -10rem;
          left: calc(((100vw - #{$container}) / 2) - 470px);
          z-index: -1;
          width: 283px;
          height: 310px;
          content: "";
          background-image: url('~@assets/images/layout/logo-jtails-small-green.svg');
          background-position: center;
          background-size: cover;
          opacity: 0.15;

          @media (max-width: #{$container + 450px}) {
            left: 1rem;
          }

          @include max-md {
            display: none;
          }
        }
      }

      &__outlineBox {
        padding: 3.75rem 10.5rem;

        @include max-md {
          padding: 2rem 0;
        }
      }

      &__detailBoxInner {
        padding: 3.75rem 10.5rem;

        @include max-md {
          padding: 2rem $container-gap;
        }

        &.isFull {
          padding: 3.75rem 2.5rem;

          @include max-md {
            padding: 2rem $container-gap;
          }

        }
      }

      &__hr {
        margin: 0 10.5rem;

        @include max-md {
          margin: 0 $container-gap;
        }
      }

      &__depositBalance {
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          color: $color-secondary;
        }
      }

      &__date {
        display: inline-block;
        padding: 0.5rem 1rem;
        margin-bottom: 1.25rem;
        font-family: $font-number;
        font-weight: 600;
        border: 1px solid $color-gray-4;
      }

      &__time {
        font-family: $font-number;
        font-size: 3rem;
        font-weight: 600;
        line-height: 1.5;
        color: $color-primary;
      }

      &__hour {
        font-size: 0.875rem;
        color: $color-gray-2;
      }
    }
  }

  &.isStyleDingBeauty {
    :global {
      .sectionDetail {
        &__detailBox {
          &::before {
            display: none;
          }
        }
      }
    }
  }

  .container {
    @include max-md {
      padding: 0;
    }
  }
}
</style>
